import React from 'react';
import { ChevronLeft } from 'lucide-react';

interface MobileHeaderProps {
  topicName: string;
  isScrolled: boolean;
  isMobile: boolean;
  isNativeApp: boolean;
  statusBarHeight: number;
  onBackClick: () => void;
}

export function MobileHeader({
  topicName,
  isScrolled,
  isMobile,
  isNativeApp,
  statusBarHeight,
  onBackClick
}: MobileHeaderProps) {
  return (
    <div
      className={`lg:hidden flex items-center h-14 px-4 sticky top-0 z-10 transition-shadow duration-200 ${
        isScrolled ? 'shadow-md' : ''
      }`}
      style={{
        paddingTop: isMobile && isNativeApp ? `${statusBarHeight}px` : '0',
        height: isMobile && isNativeApp ? `calc(3.5rem + ${statusBarHeight}px)` : '3.5rem',
      }}
    >
      <div className="flex-none">
        <button onClick={onBackClick} className="p-2 -ml-2 text-gray-600 hover:text-gray-900">
          <ChevronLeft size={24} />
        </button>
      </div>

      {/* Title - centered relative to viewport */}
      <div className="absolute left-1/2 -translate-x-1/2">
        <span className="text-base font-semibold text-gray-900 whitespace-nowrap">
          {topicName}
        </span>
      </div>
    </div>
  );
}